import { EmissionRegisterModule } from './emission/emission-register.module';
import { NgModule } from "@angular/core";

@NgModule({
  imports: [
    EmissionRegisterModule,
  ]
})
export class EmissionCreditRegisterModule {}
